import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDBodyText } from '@facet-wealth/design';
import {
  DigitalOnboardingAccountInfoOverride,
} from 'Views/Page/Content/Templates/DigitalOnboardingAccountInfo/metaOverride';
import fr from 'facet-rest';

export const metaOverride = fr.metaOverride({ base: DigitalOnboardingAccountInfoOverride })
  .nameOverride(['name'], {
    _component: () => FDBodyText,
    hidden: false,
    _customProps: { size: 'md' },
  }, { ordinal: 350 })
  .nameOverride(['accountType'], {
    _component: () => FDBodyText,
    hidden: false,
    _customProps: { size: 'sm' },
    ordinal: 200,
  }, overrideReadOnly)
  .nameOverride(['balance', 'title', 'deleteMessage', 'searchableFinancialInstitutionID'], {
    hidden: true,
  }, { ordinal: 350 });
